module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-20.5423d3de.jpg";